import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createPaymentAgreementRequest = {};
var _createPaymentAgreementResponse = {};
var _deletePaymentAgreementRequest = {};
var _deletePaymentAgreementResponse = {};
var _getPaymentAgreementInfoRequest = {};
var _getPaymentAgreementInfoResponse = {
    paymentAgreementInfo: '_paymentAgreementInfo',
};
var _getPaymentAgreementRequest = {};
var _getPaymentAgreementResponse = {};
var _listPaymentAgreementsRequest = {};
var _listPaymentAgreementsResponse = {};
var _paymentAgreementInfo = { savedPaymentMethod: '_savedPaymentMethod' };
var _savedPaymentMethod = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
function resolveWixPaymentsSavedPaymentMethodsV1PaymentAgreementServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/payments/saved-payment-methods',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function createPaymentAgreement(payload) {
    var _a = serializer(_createPaymentAgreementRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createPaymentAgreementResponse, {}).fromJSON;
    function __createPaymentAgreement(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.saved_payment_methods.v1.payment_agreement',
            method: 'POST',
            methodFqn: 'wix.payments.saved_payment_methods.v1.PaymentAgreementService.CreatePaymentAgreement',
            url: resolveWixPaymentsSavedPaymentMethodsV1PaymentAgreementServiceUrl({
                protoPath: '/v1/payment-agreements',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createPaymentAgreement.fromReq = fromReq;
    return __createPaymentAgreement;
}
createPaymentAgreement.__isAmbassador = true;
export function getPaymentAgreement(payload) {
    var _a = serializer(_getPaymentAgreementRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPaymentAgreementResponse, {}).fromJSON;
    function __getPaymentAgreement(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.saved_payment_methods.v1.payment_agreement',
            method: 'GET',
            methodFqn: 'wix.payments.saved_payment_methods.v1.PaymentAgreementService.GetPaymentAgreement',
            url: resolveWixPaymentsSavedPaymentMethodsV1PaymentAgreementServiceUrl({
                protoPath: '/v1/payment-agreements/{paymentAgreementId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPaymentAgreement.fromReq = fromReq;
    return __getPaymentAgreement;
}
getPaymentAgreement.__isAmbassador = true;
export function listPaymentAgreements(payload) {
    var _a = serializer(_listPaymentAgreementsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listPaymentAgreementsResponse, {}).fromJSON;
    function __listPaymentAgreements(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.saved_payment_methods.v1.payment_agreement',
            method: 'GET',
            methodFqn: 'wix.payments.saved_payment_methods.v1.PaymentAgreementService.ListPaymentAgreements',
            url: resolveWixPaymentsSavedPaymentMethodsV1PaymentAgreementServiceUrl({
                protoPath: '/v1/payment-agreements',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listPaymentAgreements.fromReq = fromReq;
    return __listPaymentAgreements;
}
listPaymentAgreements.__isAmbassador = true;
export function deletePaymentAgreement(payload) {
    var _a = serializer(_deletePaymentAgreementRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deletePaymentAgreementResponse, {}).fromJSON;
    function __deletePaymentAgreement(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.saved_payment_methods.v1.payment_agreement',
            method: 'DELETE',
            methodFqn: 'wix.payments.saved_payment_methods.v1.PaymentAgreementService.DeletePaymentAgreement',
            url: resolveWixPaymentsSavedPaymentMethodsV1PaymentAgreementServiceUrl({
                protoPath: '/v1/payment-agreements/{paymentAgreementId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deletePaymentAgreement.fromReq = fromReq;
    return __deletePaymentAgreement;
}
deletePaymentAgreement.__isAmbassador = true;
export function getPaymentAgreementInfo(payload) {
    var _a = serializer(_getPaymentAgreementInfoRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPaymentAgreementInfoResponse, {
        _paymentAgreementInfo: _paymentAgreementInfo,
        _savedPaymentMethod: _savedPaymentMethod,
    }).fromJSON;
    function __getPaymentAgreementInfo(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.saved_payment_methods.v1.payment_agreement',
            method: 'GET',
            methodFqn: 'wix.payments.saved_payment_methods.v1.PaymentAgreementService.GetPaymentAgreementInfo',
            url: resolveWixPaymentsSavedPaymentMethodsV1PaymentAgreementServiceUrl({
                protoPath: '/v1/payment-agreements/{paymentAgreementId}/info',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPaymentAgreementInfo.fromReq = fromReq;
    return __getPaymentAgreementInfo;
}
getPaymentAgreementInfo.__isAmbassador = true;
//# sourceMappingURL=http.impl.js.map